/**
 * Platform routes a UAT reviewer (e.g. Ronna) may access without platform-admin
 * privileges. The reviewer sees the UAT and Smoke Test checklists and nothing
 * else in the platform area.
 */
export const UAT_REVIEWER_PATHS = ['/platform/uat-checklist', '/platform/smoke-checklist'];

/** Where a UAT reviewer lands when they hit any other platform route. */
export const UAT_REVIEWER_FALLBACK = '/platform/smoke-checklist';
